import { BaseCategory } from "./BaseCategory";
import { HorizontalAlignType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class KeyConceptCategory extends BaseCategory {
    get name() {
        return "Key Concept";
    }

    get type() {
        return SlideCategories.KEY_CONCEPT;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content presents a single key concept, definition, principle, or important idea that needs emphasis. Use this when focusing on one main idea rather than multiple points.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Present the key concept, definition, or principle.
        Include the main concept/term and a clear, concise explanation or definition.
        Optionally include supporting details or examples if they add clarity.`;
    }

    getImagePrompt() {
        return "Provide a prompt for generating a 16:9 aspect ratio image to use with the key concept. The image should visually represent or relate to the concept. There should be no text in the image.";
    }

    getPromptSchema() {
        return {
            label: "optional short label or title for the concept (e.g., 'Key Concept', 'Definition', 'Question')",
            concept: "the key concept, term, or principle being defined",
            definition: "a clear, concise explanation or definition of the concept",
            details: "optional richtext supporting details or examples (can be empty string if not needed)",
            image: "an optional image prompt for the slide",
        };
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildKeyConcept(model, true, "center"),
            this.buildKeyConcept(model, true, "left"),
            this.buildKeyConcept(model, false, "center"),
        ];

        return models;
    }

    buildKeyConcept(model, showImage, position) {
        let builder = new SlideModelBuilder("headline2", model);

        if (model.details) {
            for (let block of model.details) {
                if (block.textStyle === TextStyleType.HEADING) {
                    block.textStyle = TextStyleType.TITLE;
                }
                if (block.textStyle === TextStyleType.BULLET_LIST) {
                    block.indent = (block.indent ?? 0) + 1;
                }
            }
        }

        let blocks = [
            builder.createBlock(model.label, TextStyleType.LABEL),
            builder.createBlock(model.concept, TextStyleType.HEADING),
            { type: "divider", dividerWidth: "short" },
            builder.createBlock(model.definition, TextStyleType.BODY),
            ...model.details
        ];

        let primary = {
            fullBleed: true,
            showGutter: false,
            dividerSize: 0.6666,
            headlinePosition: position,
            textAlign: HorizontalAlignType.LEFT,
            text: {
                blocks: blocks.filter(b => b)
            },
        };

        if (showImage) {
            primary.backdropStyle = "white_box";
            primary.items = [{
                componentType: "TextAndImage",
                childElement: builder.createImage(model.image)
            }];
        }

        builder.createPrimary(primary);
        return builder.model;
    }
}
